import { Dispatch } from "redux";
import * as spvBankActions from "../features/distributor/bank";
import * as spvBizActions from "../features/distributor/biz";
import * as spvRepActions from "../features/institutionalInvestor/repSlice";

export const initializeBusinessDetails = (dispatch: Dispatch, data: any) => {
  dispatch(spvBizActions.setCompanyRedux({ company: data.companyName }));
  dispatch(
    spvBizActions.setRegNumberRedux({ regNumber: data.companyRegistrationNo })
  );
  dispatch(
    spvBizActions.setLegalStructureOthersRedux({
      legalStructureOthers: data.legalStructureOthers,
    })
  );
  dispatch(
    spvBizActions.setIndustryOthersRedux({
      industryOthers: data.industryOthers,
    })
  );
  dispatch(
    spvBizActions.setLegalStructureRedux({
      legalStructure: data.legalStructure,
    })
  );
  dispatch(spvBizActions.setCountryRedux({ country: data.country }));
  dispatch(spvBizActions.setAddressRedux({ address: data.address }));
  dispatch(
    spvBizActions.setPostalRedux({ postal: data.postalCode?.toString() })
  );
  dispatch(
    spvBizActions.setIndustryGroupRedux({ industryGroup: data.industryGroup })
  );
  dispatch(
    spvBizActions.setTypeOfInstituteRedux({ typeOfInstitute: data.industry })
  );
  dispatch(
    spvBizActions.setUserFirstNameRedux({
      userFirstName: data.userFirstName?.trim(),
    })
  );
  dispatch(
    spvBizActions.setUserLastNameRedux({
      userLastName: data.userLastName?.trim(),
    })
  );
};

export const initializeBankDetails = (dispatch: Dispatch, data: any) => {
  dispatch(spvBankActions.setBankNameRedux({ bankName: data.bankName }));
  dispatch(
    spvBankActions.setAccountTypeRedux({ accountType: data.accountType })
  );
  dispatch(
    spvBankActions.setBankNoRedux({ accountNumber: data.accountNumber })
  );
  dispatch(
    spvBankActions.setAccountHolderNameRedux({
      accountHolderName: data.accountHolderName,
    })
  );
  dispatch(spvBankActions.setSwiftCodeRedux({ swiftCode: data.swiftCode }));
};

export const initializeRepDetails = (dispatch: Dispatch, data: any) => {
  dispatch(
    spvRepActions.setRepFirstNameRedux({ repFirstName: data.repFirstName })
  );
  dispatch(
    spvRepActions.setRepLastNameRedux({ repLastName: data.repLastName })
  );
  dispatch(spvRepActions.setRepTitleRedux({ repTitle: data.repTitle }));
};
